<template>
    <img :src="`/svg/icon-${name}.svg`">
</template>

<script>
export default {
    props: {
        name: {
            type: String
        }
    }
}
</script>
